module.exports = __webpack_public_path__ + "media/images/guideline/A10-8a4a69393bb872d1642e8e3932a56701.jpg";